/**
 * Rosie — NEMT Dispatch Platform
 * Copyright (c) 2025-2026 Commonwealth Transport LLC. All rights reserved.
 * PROPRIETARY AND CONFIDENTIAL. Unauthorized use, copying, or distribution is prohibited.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);